import { Box, Heading, Text, Link, Image } from '@everlywell/ui-kit';
import { IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';

interface StatImage {
  title: string;
  url?: string;
  gatsbyImageData?: IGatsbyImageData;
}

interface StatCardProps {
  heading: string;
  content: string;
  cta?: {
    text: string;
    url: string;
  };
  statImage?: StatImage;
  className?: string;
}

export const StatCard: React.FC<StatCardProps> = ({
  heading,
  content,
  cta,
  statImage,
  className,
}) => (
  <Box
    className={className}
    data-testid="stat-card"
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="space-between"
    height="100%"
  >
    <Heading as="h2" size="lg" mb={4} data-testid="stat-heading">
      {heading}
    </Heading>

    <Text mb={cta ? 4 : 0} data-testid="stat-content">
      {content}
    </Text>

    {cta && (
      <Link
        href={cta.url}
        data-testid="stat-cta"
        display="inline-block"
        mb={statImage ? 4 : 0}
      >
        {cta.text}
      </Link>
    )}

    {statImage && (
      <Image
        data-testid="stat-image"
        alt={statImage.title}
        title={statImage.title}
        src={statImage.url}
        width="100%"
        maxWidth={500}
        height="auto"
        mt={4}
      />
    )}
  </Box>
);
